/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { SyncableObservableCollection$2 } from "igniteui-react-core";
import { ColumnSummaryDescription } from "./ColumnSummaryDescription";
import { SummaryDescription } from "igniteui-react-core";
/**
 * @hidden
 */
var ColumnSummaryDescriptionCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnSummaryDescriptionCollection, _super);
    function ColumnSummaryDescriptionCollection() {
        var _this = _super.call(this) || this;
        _this.f = new SyncableObservableCollection$2(ColumnSummaryDescription.$, SummaryDescription.$, 0);
        _this.a = null;
        var a = _this.f;
        a.compare = function (b, c) { return b.w == c.propertyName && b.h == c.operand && b.d == c.calculator && b.f == c; };
        a.createFrom = function (b) {
            var c = new ColumnSummaryDescription(1, b.propertyName);
            c.h = b.operand;
            c.d = b.calculator;
            c.f = b;
            return c;
        };
        a.createTo = function (b) {
            var c = new SummaryDescription(1, b.w);
            c.operand = b.h;
            c.calculator = b.d;
            b.f = c;
            return c;
        };
        return _this;
    }
    Object.defineProperty(ColumnSummaryDescriptionCollection.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            if (a == null) {
                this.f.syncTarget = null;
                this.a = null;
                return;
            }
            this.a = a;
            this.f.syncTarget = this.a.g();
        },
        enumerable: true,
        configurable: true
    });
    ColumnSummaryDescriptionCollection.prototype.g = function (a) {
        return this.f.add(a);
    };
    ColumnSummaryDescriptionCollection.prototype.n = function (a, b) {
        this.f.add1(a, b);
    };
    ColumnSummaryDescriptionCollection.prototype.m = function () {
        this.f.clear();
    };
    ColumnSummaryDescriptionCollection.prototype.get = function (a) {
        return this.f.get(a);
    };
    ColumnSummaryDescriptionCollection.prototype.j = function (a) {
        return this.f.indexOf(a);
    };
    ColumnSummaryDescriptionCollection.prototype.h = function (a) {
        return this.f.remove1(a);
    };
    ColumnSummaryDescriptionCollection.prototype.d = function (a) {
        return this.f.remove(a);
    };
    ColumnSummaryDescriptionCollection.prototype.set = function (a, b) {
        return this.f.set(a, b);
    };
    ColumnSummaryDescriptionCollection.prototype.size = function () {
        return this.f.size();
    };
    ColumnSummaryDescriptionCollection.prototype.l = function (a) {
        this.f.addListener(a);
    };
    ColumnSummaryDescriptionCollection.prototype.o = function (a) {
        this.f.removeListener(a);
    };
    Object.defineProperty(ColumnSummaryDescriptionCollection.prototype, "i", {
        get: function () {
            return this.f.all;
        },
        enumerable: true,
        configurable: true
    });
    ColumnSummaryDescriptionCollection.$t = markType(ColumnSummaryDescriptionCollection, 'ColumnSummaryDescriptionCollection');
    return ColumnSummaryDescriptionCollection;
}(Base));
export { ColumnSummaryDescriptionCollection };
//# sourceMappingURL=ColumnSummaryDescriptionCollection.js.map
